import {ReactElement, ReactNode, Suspense} from 'react';
import LoadingDialog from '@components/LoadingDialog/LoadingDialog';

interface Props {
    children: ReactNode;
}

export default function Async(props: Props): ReactElement<Props> {
    return <Suspense fallback={<LoadingDialog isOpen />}>{props.children}</Suspense>;
}
